/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Learningreportdescription2Inputs */

const zh_learn_learningreportdescription2 = /** @type {(inputs: Learn_Learningreportdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于本次学习数据和相关知识点的 AI 深度分析`)
};

const en_learn_learningreportdescription2 = /** @type {(inputs: Learn_Learningreportdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-powered analysis based on your learning data and related knowledge areas`)
};

const es_learn_learningreportdescription2 = /** @type {(inputs: Learn_Learningreportdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis impulsado por IA basado en tus datos de aprendizaje y áreas de conocimiento relacionadas`)
};

/**
* | output |
* | --- |
* | "AI-powered analysis based on your learning data and related knowledge areas" |
*
* @param {Learn_Learningreportdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_learningreportdescription2 = /** @type {((inputs?: Learn_Learningreportdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Learningreportdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_learningreportdescription2(inputs)
	if (locale === "en") return en_learn_learningreportdescription2(inputs)
	return es_learn_learningreportdescription2(inputs)
});
export { learn_learningreportdescription2 as "learn_learningReportDescription" }